import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { TranslateModule } from '@ngx-translate/core';

import { CssRulesAngularModule } from 'rev-shared/ui/css/Css.AngularModule';
import { FormDirectivesAngularModule } from 'rev-shared/util/directives/form/FormDirectivesAngular.Module';
import { SpinnerAngularModule } from 'rev-shared/ui/spinner/SpinnerAngular.Module';
import { VbBtnPrimaryDirective } from 'rev-shared/ui/buttons/VbBtnPrimary.Directive';
import { VbBtnSecondaryDirective } from 'rev-shared/ui/buttons/VbBtnSecondary.Directive';
import { VbBtnWhiteDirective } from 'rev-shared/ui/buttons/VbBtnWhite.Directive';
import { VbUiRadioBtnDirective } from 'rev-shared/ui/buttons/VbUiRadioBtnAngular.Directive';
import { VbUiRadioBtnGroupDirective } from 'rev-shared/ui/buttons/VbUiRadioBtnGroupAngular.Directive';
import { VbUiTextInputDirective } from 'rev-shared/ui/textInput/VbUiTextInput.Directive';

import { VbUiInlineEditBooleanComponent } from './VbUiInlineEditBoolean.Component';
import { VbUiInlineTextEditComponent } from './VbUiInlineTextEdit.Component';
import { VbUiTypeaheadAngularComponent } from './VbUiTypeAheadAngular.Component';

const components = [
	VbUiInlineEditBooleanComponent,
	VbUiInlineTextEditComponent,
	VbUiTypeaheadAngularComponent
];

@NgModule({
	imports: [
		CommonModule,
		CssRulesAngularModule,
		FormDirectivesAngularModule,
		FormsModule,
		SpinnerAngularModule,
		TranslateModule,
		TypeaheadModule,
		VbBtnPrimaryDirective,
		VbBtnSecondaryDirective,
		VbBtnWhiteDirective,
		VbUiRadioBtnDirective,
		VbUiRadioBtnGroupDirective,
		VbUiTextInputDirective
	],
	declarations: components,
	exports: components,
})
export class InlineEditAngularModule { }
